/**
 * @file PriceWithUnit.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-28
 * @modified 2026-10-28
 * @description A unit price or unit cost with what it is per, on screens that
 *              show (not edit) a line: "£400.00/T", "£10.00/25kg bag" with
 *              "= £400.00/T" beneath, "£5.00 each", "£58.00/bag", and "£6.15"
 *              over "unit not set" where nothing gives one (Cam, 28 Oct 2026 —
 *              "so long as the user is totally clear what £/ unit UNITS
 *              actually are (i.e. whether £100/T or /Tote or /25kg Bag etc.)").
 *              The rule is utils/unitPriceLabel; the money is formatPrice.
 *
 *   <PriceWithUnit value={line.unit_price} line={line} />        a row in either naming
 *   <PriceWithUnit value={x} facts={{ unitWeightKg: 25 }} />     facts given
 *   perTonne={false}  leaves off the "= £…/T" of a pack line.
 */

import React from 'react';
import { formatPrice } from '../utils/currencyFormatter';
import { perUnitOf, perTonne as perTonneOf, priceFactsOf, UNIT_NOT_SET } from '../utils/unitPriceLabel';
import './PriceWithUnit.css';

const blank = (v) => v === null || v === undefined || v === '';

function PriceWithUnit({ value, line = null, facts = null, perTonne = true, className = '', format = formatPrice }) {
  if (blank(value)) return <span className={`price-with-unit is-blank ${className}`.trim()}>-</span>;
  const f = facts || priceFactsOf(line || {});
  const p = perUnitOf(f);
  const t = perTonne ? perTonneOf(value, f) : null;
  const unknown = p.kind === 'unknown';
  return (
    <span className={`price-with-unit${unknown ? ' unit-unknown' : ''} ${className}`.trim()} title={p.title}>
      <span className="pwu-main">
        {format(value)}
        {!unknown && <span className="pwu-per">{p.per}</span>}
      </span>
      {unknown && <span className="pwu-sub pwu-warn">{UNIT_NOT_SET}</span>}
      {t ? <span className="pwu-sub">= {format(t)}/T</span> : null}
    </span>
  );
}

export default PriceWithUnit;
